/** Presentation-only timing: independent of simulation ticks or frame rate. */
export const ERA_TRANSITION_SECONDS = 2.8;
export const ERA_SWITCH_PROGRESS = 0.4;

const smooth = (x: number) => { const t = Math.max(0, Math.min(1, x)); return t * t * (3 - 2 * t); };

export function transitionFrame(elapsed: number) {
  const progress = Math.max(0, Math.min(1, elapsed / ERA_TRANSITION_SECONDS));
  const lift = progress < 0.65 ? smooth(progress / 0.4) : 1 - smooth((progress - 0.65) / 0.35);
  return { progress, lift, presence: 1 - lift, switched: progress >= ERA_SWITCH_PROGRESS, done: progress >= 1 };
}
